
import '@/assets/scss/index.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'

export default {
  components: {
  },
  mixins: [pdMixin],
  props: {
    pdNo: { // 상품 데이터
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      visible: false,
      form: {
        iqrySeCd: 'E',
        iqryTyCd: '05',
        iqrySj: '',
        iqryCn: '',
        pdNo: '',
        sectYn: false
      },
      rules: {
        iqrySj: [
          { required: true, message: '문의 제목을 입력해주세요.', trigger: 'blur' },
          { min: 2, message: '문의 제목은 2자 이상 입력해야 합니다.', trigger: 'blur' },
          { max: 40, message: '문의 제목은 40자 이하로 입력해야 합니다.', trigger: 'blur' }
        ],
        iqryCn: [
          { required: true, message: '문의 내용을 입력해주세요.', trigger: 'blur' },
          { min: 2, message: '문의 내용은 2자 이상 입력해야 합니다.', trigger: 'blur' },
          { max: 1000, message: '문의 내용은 1000자 이하로 입력해야 합니다.', trigger: 'blur' },
          { validator: this.privateInfoCheck, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible (flag) {
      if (flag) {
        this.form.pdNo = this.pdNo
      } else {
        this.$refs.form.resetFields() // validate 초기화
        this.form.sectYn = false // 비밀글 체크박스 초기화
      }
    }
  },
  methods: {
    close () {
      // 작성한 내용이 사라집니다. 문의 작성을 중단하시겠습니까?
      this.confirm(this.$t('MB.STOP_INQUIRY_CONFIRM'), {
        okCallback: () => {
          this.visible = false
        }
      })
    },

    // form validation focus
    async checkValidate () {
      await this.$refs.form.validate((valid, obj) => {
        if (!valid) {
          // validate check object 첫번째 필드 포커스
          const field = Object.keys(obj)[0]
          this.$refs[field].focus()
        } else {
          this.saveQna()
        }
      })
    },

    // qna 저장
    saveQna () {
      this.$AxiosBuilder
        .data(this.form)
        .build()
        .post('/cs/csn/savePdIqry')
        .then((res) => {
          if (res.data.success) {
            // 문의 사항이 등록되었습니다.
            this.alert(this.$t('MB.SAVE_INQUIRY_SUCCESS'), {
              okCallback: () => {
                this.$emit('reload')
                this.visible = false
              }
            })
          } else {
            console.log(res.data.message)
            // 저장에 실패했습니다.
            this.alert(this.$t('CM.SAVE_FAIL'), {
              // hssong 세션 초기화 테스트
              okCallback: () => {
                this.$store.commit('session/setMember', {}) // 세션객체 초기화
                this.$router.push({ path: '/mb/mbb/SCR_MBB_0097A', query: { returnUrl: window.location.href } })
              },
            })
          }
        }).catch((e) => {
          console.log('LayerQnaWrt saveQna error : ', e)
        })
    },

    // input maxlength 이상 입력 안되게
    checkLength (obj) {
      const el = this.$refs[obj].$el.querySelector('textarea')
      this.form[obj] = el.value.slice(0, el.maxLength)
    },
    // 1:1문의하기로 이동
    moveCs () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      // 고객센터 문의하기 이동
      this.$router.push('/cs/csl/SCR_CSL_0001')
    },
    privateInfoCheck (rule, value, callback) {
      if (this.isNotEmpty(value)) {
        // 1. 이메일
        if (this.emailIncdChk(value)) {
          callback(new Error('작성 내용 중 개인정보(이메일)가 포함되어 있습니다.'))
        }

        // 2. 카드번호 / 전화번호
        if (this.cardIncdChk(value)) {
          callback(new Error('작성 내용 중 개인정보(카드번호)가 포함되어 있습니다.'))
        } else if (this.phoneIncdChk(value)) {
          callback(new Error('작성 내용 중 개인정보(전화번호)가 포함되어 있습니다.'))
        }

        // 3. 주민등록번호
        if (this.rrnIncdChk(value)) {
          callback(new Error('작성 내용 중 개인정보(주민등록번호)가 포함되어 있습니다.'))
        }

        // 4. 운전면허번호
        if (this.driveLicenseIncdChk(value)) {
          callback(new Error('작성 내용 중 개인정보(운전면허번호)가 포함되어 있습니다.'))
        }
      }

      callback()
    }
  }
}
